import React from 'react'

import { captureChunkLoadError } from '@client/utils/sentry'

const RELOAD_STORAGE_KEY = 'chunkLoadError:reload'
const RELOAD_DEBOUNCE_MS = 10000

const importHandleError = (loader) => {
  return React.lazy(async () => {
    let component
    try {
      component = await loader()
    } catch (e) {
      if (e?.name === 'ChunkLoadError') {
        // A stale chunk hash from a superseded deploy. Report it, then reload
        // once (debounced via sessionStorage against reload loops) so the user
        // transparently lands on the current build instead of a permanently
        // blank panel. Other errors keep the existing silent-null fallback.
        captureChunkLoadError(e)
        const lastReload = sessionStorage.getItem(RELOAD_STORAGE_KEY)
        if (
          !lastReload ||
          Date.now() - Number(lastReload) > RELOAD_DEBOUNCE_MS
        ) {
          sessionStorage.setItem(RELOAD_STORAGE_KEY, String(Date.now()))
          window.location.reload()
        }
      }
      component = {
        default: () => null,
      }
    }
    return component
  })
}

export default importHandleError
